import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    gap: 16px;
    justify-content: center;
    text-align: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: 100%;
      margin-bottom: 52px;
    }
  `};
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.extraDark};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
  `};
`;

export const Message = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0;
  `};
`;

export const ButtonContainer = styled.div`
  width: fit-content;
  margin-top: 16px;
`;
